import { CurrencyString } from "../types/product";

export function formatCurrency(value: number, currency: CurrencyString) {
  if (value === undefined) return undefined;
  return getCurrencyFormatter(currency).format(value);
}

function getCurrencyFormatter(currency: CurrencyString) {
  switch (currency) {
    case "HKD":
      return new Intl.NumberFormat("en-US", {
        currency: "HKD",
        style: "currency",
      });
    case "CNY":
      return new Intl.NumberFormat("en-US", {
        currency: "CNY",
        currencyDisplay: "narrowSymbol",
        style: "currency",
      });
    case "USD":
      return new Intl.NumberFormat("en-US", {
        currency: "USD",
        style: "currency",
      });
  }
}
